import { Grid } from '@mui/material';
import { ContainerFooter } from './style';
import ImgFooter from '../../../../assets/svg/footer.svg';
import LogoFayven from '../../../../assets/svg/logofayven.svg';

export default function FooterHomePage() {
  return (
    <Grid container>
      <ContainerFooter src={ImgFooter}>
        <Grid container style={{ marginTop: '200px' }}>
          <Grid item xs={1} />
          <Grid item xs={3}>
            <img src={LogoFayven} alt="logo" style={{ width: '100%' }} />
          </Grid>
        </Grid>
      </ContainerFooter>
    </Grid>
  );
}
